// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jvjylijgdcryepysoowr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp2anlsaWpnZGNyeWVweXNvb3dyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg2MjgwOTYsImV4cCI6MjA1NDIwNDA5Nn0.CffIMXmDIOteys76ufTRTVaY0beY6DeM757-gbHAGUM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);